import Popup from "reactjs-popup";
import {Section} from "./Section";
import PropTypes from "prop-types";

export function ModalPopUp(props) {
    const {open, onOpenChanged, modalContent} = props;
    return <Popup key={"modal"} lockScroll={true} onClose={() => onOpenChanged(false)} open={open}
                  closeOnDocumentClick={false}
                  contentStyle={STYLE_POPUP_CONTENT}
                  overlayStyle={STYLE_POPUP_OVERLAY}
                  arrowStyle={STYLE_POPUP_ARROW}
                  children={modalContent}/>
}


ModalPopUp.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool,
    onOpenChanged: PropTypes.func,
    modalContent: PropTypes.element
};


const STYLE_POPUP_CONTENT = {
    background: "rgb(255, 255, 255)",
    width: '100%',
    height: '100%',
    padding: "5px",
    overflow: 'auto'

}

const STYLE_POPUP_OVERLAY = {
    background: "rgba(0, 0, 0, 0.8)",

}

const STYLE_POPUP_ARROW = {
    color: "rgb(255, 255, 255)",
}

